<template>
  <div id="pagination-area" class="mt-4">
    <vs-row vs-w="12">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="4" vs-xs="12">
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
        <div>
          <vs-pagination
            :total="totalPage"
            :max="totalReportCount"
            v-model="current"
          ></vs-pagination>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import {DeviceInfoMixin, ColorMixin} from "@/mixins";

import {createNamespacedHelpers} from "vuex";

const {mapState, mapMutations} = createNamespacedHelpers("vesselNoonReportList");

export default {
  mixins: [DeviceInfoMixin, ColorMixin],
  computed: {
    ...mapState(["currentPage", "totalReportCount", "totalPage", "paginationPageSize"]),

    fromCount() {
      return this.paginationPageSize * this.currentPage + 1;
    },

    toCount() {
      const count = Math.min(this.totalReportCount, this.paginationPageSize * (this.currentPage + 1));
      return count;
    },

    current: {
      get() {
        return this.currentPage + 1;
      },
      set(val) {
        const count = val - 1;
        this.SET_CURRENT_PAGE(count);
      }
    },
  },
  methods: {
    ...mapMutations(["SET_CURRENT_PAGE"]),
  },
}
</script>

<style>
.total-page {
  width: 120px !important;
}
</style>
